<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- 25.9.11 轮播图 dxm -->
    <div
      class="swiper-container banner-swiper"
      v-if="bannerList.length > 0"
      ref="bannerDiv"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in bannerList"
          :key="item.id"
          :data-id="item.id"
        >
          <img :src="langSet == 'cn' ? item.img : item.en_img" alt />
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <buttons></buttons>
    <div class="index_wrap">
      <!-- 介绍 -->
      <introduce
        v-if="introduceData.area"
        :introduceData="introduceData"
      ></introduce>
      <!-- 商机在线 -->
      <business></business>
      <!-- 会议 -->
      <meeting></meeting>
      <!-- 热度榜 -->
      <popularity v-if="popularityList" :list="popularityList"></popularity>
      <!-- 活动 -->
      <active></active>
      <!-- 新闻资讯 -->
      <news></news>
      <!-- 合作媒体 -->
      <partner
        :title="langSet == 'cn' ? '合作媒体' : 'Media Partners'"
        targetId="partners"
        v-if="partnerList.mediaPartners"
        :partnerData="partnerList.mediaPartners"
      ></partner>
      <!-- 支持单位 -->
      <partner
        :title="langSet == 'cn' ? '支持单位' : 'Sponsors'"
        targetId="sponsors"
        v-if="partnerList.supportUnit"
        :partnerData="partnerList.supportUnit"
      ></partner>
      <!-- 相关展会 -->
      <partner
        :title="langSet == 'cn' ? '相关展会' : 'Other Related Exhibitions'"
        targetId="exhibitions"
        v-if="partnerList.relateExhibitors"
        :partnerData="partnerList.relateExhibitors"
      ></partner>
      <!-- 品牌展商 -->
      <partner
        :title="langSet == 'cn' ? '品牌展商' : 'Exhibiting Brands'"
        targetId="brands"
        v-if="partnerList.brandExhibitors"
        :partnerData="partnerList.brandExhibitors"
      ></partner>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import buttons from "./components/button.vue";
import introduce from "./components/introduce.vue";
import business from "./components/business.vue";
import meeting from "./components/meeting.vue";
import popularity from "./components/popularity.vue";
import active from "./components/active.vue";
import news from "./components/news.vue";
import partner from "./components/partner.vue";
import Swiper from "swiper"; // 注意引入的是Swiper
import "../../../node_modules/swiper/css/swiper.min.css"; //
import { getPartner, slideList, getWebsite } from "@/api/api";
import { exhibitorLists } from "@/api/company_api";
export default {
  name: "index",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.desc,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    buttons,
    introduce,
    business,
    meeting,
    popularity,
    active,
    news,
    partner,
  },
  data() {
    return {
      langSet: "",
      partnerList: [],
      swiper: null,
      bannerList: [],
      metaData: {},
      popularityList: [],
      introduceData: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.metaData = JSON.parse(localStorage.getItem("metaData"));
    //25.9.15 获取轮播图 dxm
    this.getSlideList();
    //25.9.18 获取基本信息 dxm
    this.getWebsiteData();
    //25.9.15 获取企业热度榜 dxm
    this.exhibitorData();
    //25.9.15 获取合作伙伴 dxm
    this.getPartnerList();
  },
  methods: {
    async getSlideList() {
      let data = {
        type: 1,
      };
      const res = await slideList(data);
      this.bannerList = res.data.lists;
      let that = this;
      setTimeout(() => {
        const mySwiper = new Swiper(".banner-swiper", {
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          on: {
            tap: function (swiper, event) {
              const realIndex = mySwiper.realIndex;
              const item = that.bannerList[realIndex];
              that.toLink(item);
            },
          },
        });
      }, 300);
    },
    async exhibitorData() {
      let data = {
        hot: 1,
        page_size: 10,
      };
      const res = await exhibitorLists(data);
      this.popularityList = res.data.lists;
    },
    async getPartnerList() {
      const res = await getPartner();
      this.partnerList = res.data;
    },
    async getWebsiteData() {
      let data = {
        type: "home",
      };
      const res = await getWebsite(data);
      let {
        area,
        audience_num,
        company_num,
        interface_meeting,
        frontier,
        expert,
      } = res.data;
      this.introduceData = {
        area,
        audience_num,
        company_num,
        interface_meeting,
        frontier,
        expert,
      };
    },
    toLink(item, index) {
      if (item.url_type == 1) {
        this.$router.push({
          path: this.langSet == "cn" ? item.url : item.en_url,
        });
      } else if (item.url_type == 2) {
        window.open(this.langSet == "cn" ? item.url : item.en_url, "_blank");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home-exhibition-time {
  width: 1280px;
  display: block;
  margin: 40px auto 466px;
}
.main_partners {
  padding-top: 60px;
  .mp_img {
    width: 300px;
    margin: 25px auto 0;
  }
  .mp_imgen {
    width: 400px;
  }
}

// 轮播图样式
.banner-swiper {
  width: 100%;
  position: relative;
  // height: 900px;
  &::before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 96px;
    z-index: 99;
    background: url("../../assets/banner_bg.jpg") no-repeat;
    background-size: 100% 100%;
  }
  .swiper-wrapper {
    // display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    flex-wrap: nowrap;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-slide {
    width: 100% !important;
    text-align: center;
    font-size: 18px;
    background: #fff;
    cursor: pointer;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    // -webkit-justify-content: center;
    // justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.index_wrap {
  padding-bottom: 70px;
}
@media only screen and (max-width: 1280px) {
  .home-exhibition-time {
    width: 90%;
    display: block;
    margin: 40px auto 466px;
  }
}

@media only screen and (max-width: 767px) {
  .home-exhibition-time {
    width: 100%;
    display: block;
    padding: 0 0 1rem;
    margin: 0;
  }
  .index_wrap {
    width: 100%;
    height: auto;
  }
  .banner-swiper {
    height: auto;
    &::before {
      height: 30px;
      background: url("../../assets/mbanner_bg.jpg") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>